<template>
  <div class="form-item" :class="{ '--has-error': v.$error }">
    <label class="form__label" for="email">
      <span class="form__label-text">{{ label }}</span>
      <FormError
        data-testid="email-required-error"
        v-if="v.$error && !v.required"
        msg="Email address required"
      />
      <FormError
        v-if="
          !(v.$error && !v.required) && ((v.$error && !v.email) || errorMessage)
        "
        data-testid="email-invalid-error"
        :msg="errorMessage || 'Valid email address required'"
      />
    </label>
    <div class="form__input email-wrapper">
      <input
        id="email"
        data-testid="email"
        class="email-input"
        type="email"
        autocomplete="email"
        :name="name"
        :value="value"
        @input="update"
        @blur="emailBlur($event.target.value)"
      />
      <div v-if="emailSuggestion" class="suggestion">
        Did you mean
        <button @click="useSuggestion">
          {{ emailSuggestion }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Mailcheck from "mailcheck";
import FormError from "@/components/forms/FormError";

export default {
  name: "EmailInput",
  components: {
    FormError,
  },
  data() {
    return {
      emailSuggestion: null,
    };
  },
  props: {
    name: String,
    label: String,
    value: String,
    v: Object,
    errorMessage: String,
  },
  methods: {
    emailBlur(emailValue) {
      Mailcheck.run({
        email: emailValue,
        suggested: (suggestion) => {
          this.emailSuggestion = suggestion.full;
        },
        empty: () => {
          this.emailSuggestion = null;
        },
      });
    },
    update(e) {
      if (this.emailSuggestion) {
        this.emailSuggestion = null;
      }

      this.$emit("input", e.target.value);
    },
    useSuggestion() {
      this.$emit("input", this.emailSuggestion);
      this.emailSuggestion = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.email-wrapper {
  -webkit-appearance: textfield;
  padding: $spacing-small;

  @include media("<medium") {
    padding: $spacing-xs;
  }

  .email-input {
    appearance: none;
    outline: none;
    border: none;
    display: block;
    padding: 0;
    width: 100%;
    font-size: $form-font-size;
  }

  .suggestion {
    color: $brand-orange;
    font-size: $small-font-size;

    button {
      appearance: none;
      border: none;
      padding: 0;
      background: transparent;
      text-decoration: underline;
      font-size: $small-font-size;
      color: $brand-orange;
      cursor: pointer;

      &:hover {
        color: darken($brand-orange, 5%);
      }
    }
  }
}
</style>
